<mat-sidenav-container class="userlist-filter__container">
  <mat-sidenav
    class="userlist-filter__sidenav"
    position="end"
    mode="over"
    [opened]="opened"
    (openedChange)="openedChange.emit($event)"
  >
    <div class="userlist-filter__sidenav-header">
      <h3>Filter</h3>

      <div class="userlist-filter__filter-buttons">
        <button mat-raised-button type="button" (click)="onReset()">
          {{ 'userlist.filter.reset' | translate }}
        </button>

        <button mat-flat-button type="button" (click)="onApply()">
          {{ 'userlist.filter.apply' | translate }}
        </button>
      </div>
    </div>

    <mat-divider></mat-divider>

    <div class="userlist-filter__sidenav-body">

      <div class="userlist-filter__sidenav-container">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'userlist.filter.name' | translate }}</mat-label>
          <input
            matInput
            [(ngModel)]="filter.consultantName"
            [placeholder]="'userlist.filter.name' | translate"
          />
        </mat-form-field>
      </div>

      <mat-divider></mat-divider>

      <div class="userlist-filter__sidenav-container">
        <mat-label class="userlist-filter__label">{{ 'userlist.filter.travel' | translate }}</mat-label>

        <mat-button-toggle-group
          class="userlist-filter__travel-group"
          [(ngModel)]="filter.travelWillingness"
          name="travelWillingness"
        >
          <mat-button-toggle value="Ja">
            {{ 'userlist.filter.travelYes' | translate }}
          </mat-button-toggle>
          <mat-button-toggle value="Eingeschränkt">
            {{ 'userlist.filter.travelRestricted' | translate }}
          </mat-button-toggle>
          <mat-button-toggle value="Nein">
            {{ 'userlist.filter.travelNo' | translate }}
          </mat-button-toggle>
        </mat-button-toggle-group>
      </div>

      <mat-divider></mat-divider>

      <div class="userlist-filter__sidenav-container">
        <mat-form-field appearance="outline">
          <mat-label class="userlist-filter__label">{{ 'userlist.filter.advisor' | translate }}</mat-label>

          <mat-select
            [(ngModel)]="filter.advisor"
            name="select_advisor"
            [compareWith]='compareAdvisors'
          >
            @for (advisor of advisorOptions; track advisor) {
              <mat-option [value]="advisor">
                {{ advisor.firstName }} {{ advisor.lastName }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      <mat-divider></mat-divider>

      <div class="userlist-filter__sidenav-container">
        <mat-label class="userlist-filter__label">{{ 'userlist.filter.applicant' | translate }}</mat-label>
        <mat-checkbox [(ngModel)]="filter.isApplicant">
          {{ 'userlist.filter.isApplicant' | translate }}
        </mat-checkbox>
      </div>

      <div class="userlist-filter__sidenav-container">
        <mat-label class="userlist-filter__label">{{ 'userlist.filter.freelancer' | translate }}</mat-label>
        <mat-checkbox [(ngModel)]="filter.isFreelancer">
          {{ 'userlist.filter.isFreelancer' | translate }}
        </mat-checkbox>
      </div>

      <mat-divider></mat-divider>

      <div class="userlist-filter__sidenav-container">
        <mat-form-field appearance="outline">
          <input matInput [matDatepicker]="datepicker" [(ngModel)]="filter.availableFrom"/>
          <mat-label>{{ 'userlist.filter.available' | translate }}</mat-label>
          <mat-datepicker-toggle matIconSuffix [for]="datepicker"></mat-datepicker-toggle>
          <mat-datepicker #datepicker>
            <mat-datepicker-actions>
              <button mat-button matDatepickerCancel type="button">
                {{ 'general.cancel' | translate }}
              </button>
              <button mat-flat-button matDatepickerApply type="button">
                {{ 'general.apply' | translate }}
              </button>
            </mat-datepicker-actions>
          </mat-datepicker>
        </mat-form-field>
      </div>

      <mat-divider></mat-divider>

      <div class="userlist-filter__sidenav-container">
        <mat-label class="userlist-filter__label">{{ 'userlist.filter.profilerLanguage' | translate }}</mat-label>

        <mat-button-toggle-group
          class="userlist-filter__profiler-language-group"
          [(ngModel)]="filter.profilerLanguage"
          name="profilerLanguage"
        >
          <mat-button-toggle [value]="null">
            {{ 'userlist.filter.all' | translate }}
          </mat-button-toggle>
          @for (language of profilerLanguages; track language) {
            <mat-button-toggle [value]="language">
              <app-profiler-language-flag
                [langKey]="language"
                [showTooltip]="false"
              ></app-profiler-language-flag>
              {{ profilerLanguageLabelKey(language) | translate }}
            </mat-button-toggle>
          }
        </mat-button-toggle-group>
      </div>

      <mat-divider></mat-divider>

      <div class="userlist-filter__sidenav-container">
        <app-dropdown-card-field
          [(ngModel)]="filter.languages"
          [items]="languageOptions"
          [label]="'userlist.filter.language' | translate"
          [displayWith]="languageLabel"
          [compareWith]="compareLanguage"
          [panelClass]="'userlist-filter__select-panel'"
        ></app-dropdown-card-field>

        <mat-checkbox [(ngModel)]="filter.isLanguagesAndMode">
          {{ 'userlist.filter.some' | translate }}
        </mat-checkbox>
      </div>

      <mat-divider></mat-divider>

      <div class="userlist-filter__sidenav-container">
        <app-dropdown-card-field
          [(ngModel)]="filter.branches"
          [items]="allIndustries"
          [label]="'userlist.filter.branches' | translate"
          [displayWith]="vocabularyLabel"
          [compareWith]="compareRequests"
          [panelClass]="'userlist-filter__select-panel'"
        ></app-dropdown-card-field>


        <mat-checkbox [(ngModel)]="filter.isBranchesAndMode">
          {{ 'userlist.filter.some' | translate }}
        </mat-checkbox>
      </div>

      <mat-divider></mat-divider>

      <div class="userlist-filter__sidenav-container">
        <app-filter
          (deleteRequests)="deleteProjectCompany.emit($event)"
          (editRequests)="editProjectCompany.emit($event)"
          [filterMode]="filter.isProjectCompanyAndMode"
          [filterType]="filter.projectCompany"
          [titel]="'userlist.filter.projectsCompany'"
        ></app-filter>
      </div>

      <mat-divider></mat-divider>

      <div class="userlist-filter__sidenav-container">
        <app-filter
          (deleteRequests)="deleteProjectRole.emit($event)"
          (editRequests)="editProjectRole.emit($event)"
          [filterMode]="filter.isProjectRolesAndMode"
          [filterType]="filter.projectRole"
          [titel]="'userlist.filter.projectRole'"
        ></app-filter>
      </div>

      <mat-divider></mat-divider>

      <div class="userlist-filter__sidenav-container">
        <app-dropdown-card-field
          [(ngModel)]="filter.focuses"
          [items]="allMainFocuses"
          [label]="'userlist.filter.focuses' | translate"
          [displayWith]="vocabularyLabel"
          [compareWith]="compareRequests"
          [panelClass]="'userlist-filter__select-panel'"
        ></app-dropdown-card-field>

        <mat-checkbox [(ngModel)]="filter.isFocusesAndMode">
          {{ 'userlist.filter.some' | translate }}
        </mat-checkbox>
      </div>

      <mat-divider></mat-divider>

      <div class="userlist-filter__sidenav-container">
        <app-filter
          (deleteRequests)="deleteEducation.emit($event)"
          (editRequests)="editEducation.emit($event)"
          [filterMode]="filter.isEducationAndMode"
          [filterType]="filter.education"
          [titel]="'userlist.filter.educationName'"
        ></app-filter>
      </div>

      <mat-divider></mat-divider>

      <div class="userlist-filter__sidenav-container">
        <app-filter
          (deleteRequests)="deleteEducationInstitution.emit($event)"
          (editRequests)="editEducationInstitution.emit($event)"
          [filterMode]="filter.isEducationInstitutionAndMode"
          [filterType]="filter.educationInstitution"
          [titel]="'userlist.filter.educationInstitution'"
        ></app-filter>
      </div>

      <mat-divider></mat-divider>

      <div class="userlist-filter__sidenav-container">
        <app-dropdown-card-field
          [(ngModel)]="filter.skills"
          [items]="allSkills"
          [label]="'userlist.filter.skills' | translate"
          [displayWith]="skillLabel"
          [compareWith]="compareSkills"
          [searchFn]="skillSearchFn"
          [panelClass]="'userlist-filter__select-panel'"
        ></app-dropdown-card-field>

        <mat-checkbox [(ngModel)]="filter.isSkillsAndMode">
          {{ 'userlist.filter.some' | translate }}
        </mat-checkbox>
      </div>

      <mat-divider></mat-divider>

      <div class="userlist-filter__sidenav-container">
        <app-dropdown-card-field
          [(ngModel)]="filter.trainings"
          [items]="allTrainings"
          [label]="'userlist.filter.trainings' | translate"
          [displayWith]="requestLabel"
          [compareWith]="compareRequests"
          [panelClass]="'userlist-filter__select-panel'"
        ></app-dropdown-card-field>

        <mat-checkbox [(ngModel)]="filter.isTrainingsAndMode">
          {{ 'userlist.filter.some' | translate }}
        </mat-checkbox>
      </div>

      <mat-divider></mat-divider>

      <div class="userlist-filter__sidenav-container">
        <app-dropdown-card-field
          [(ngModel)]="filter.certificates"
          [items]="allCertificates"
          [label]="'userlist.filter.certificates' | translate"
          [displayWith]="certificateLabel"
          [panelClass]="'userlist-filter__select-panel'"
        ></app-dropdown-card-field>

        <mat-checkbox [(ngModel)]="filter.isCertificatesAndMode">
          {{ 'userlist.filter.some' | translate }}
        </mat-checkbox>
      </div>

      <mat-divider></mat-divider>

      <div class="userlist-filter__sidenav-container">
        <app-dropdown-card-field
          [(ngModel)]="filter.catalog"
          [items]="allCatalogues"
          [label]="'userlist.filter.catalog' | translate"
          [displayWith]="catalogLabel"
          [compareWith]="compareCatalog"
          [searchFn]="catalogSearchFn"
          [panelClass]="'userlist-filter__select-panel'"
        ></app-dropdown-card-field>

        <mat-checkbox [(ngModel)]="filter.isCatalogAndMode">
          {{ 'userlist.filter.some' | translate }}
        </mat-checkbox>
      </div>

      <mat-divider></mat-divider>

      <div class="userlist-filter__sidenav-container">
        <mat-form-field appearance="outline">
          <input matInput [matDatepicker]="securityCheckPicker" [(ngModel)]="filter.securityCheckCompletedOn"/>
          <mat-label>{{ 'userlist.filter.securityCheckCompletedOn' | translate }}</mat-label>
          <mat-datepicker-toggle matIconSuffix [for]="securityCheckPicker"></mat-datepicker-toggle>
          <mat-datepicker #securityCheckPicker>
            <mat-datepicker-actions>
              <button mat-button matDatepickerCancel type="button">
                {{ 'general.cancel' | translate }}
              </button>
              <button mat-flat-button matDatepickerApply type="button">
                {{ 'general.apply' | translate }}
              </button>
            </mat-datepicker-actions>
          </mat-datepicker>
        </mat-form-field>
      </div>
    </div>
  </mat-sidenav>

  <mat-sidenav-content class="userlist-filter__content">
    <ng-content></ng-content>
  </mat-sidenav-content>
</mat-sidenav-container>
